import React, { forwardRef, memo } from 'react';
import { Card, CardActions } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';

import { IconButton } from '../../material-ui/IconButton';
import { Typography } from '../../material-ui/Typography';
import { useStyles } from './useStyles';
import { TYPES } from '../../../actions/modal';
import { SnackIcon } from '../SnackIcon/SnackIcon';

const Message = {
    [TYPES.CHECK_ALTITUDE]: 'messages.tapToCheckAltitude',
    [TYPES.SHORT_POINT]: 'messages.tapToCheckFuel',
};

export const AlertMessage = memo(
    forwardRef(({ id, message, variant, callback, onDismiss }, ref) => {
        const classes = useStyles();
        const { closeSnackbar } = useSnackbar();
        const { t: translate } = useTranslation();

        const handleDismiss = React.useCallback(
            (evt) => {
                evt.stopPropagation();
                onDismiss(true);
                closeSnackbar(id);
            },
            [id, onDismiss]
        );

        const handleAlertClick = React.useCallback(() => {
            callback();
            closeSnackbar(id);
        }, [id, callback]);

        return (
            <Card onClick={handleAlertClick} className={classes.card} ref={ref}>
                <CardActions classes={{ root: classes.actionRoot }}>
                    <Typography variant="subtitle2" className={classes.title}>
                        <div className={classes.iconWrapper}>
                            <SnackIcon variant={variant} className={classes.icon} />
                        </div>
                        {translate(Message[message])}
                    </Typography>
                    <div className={classes.icons}>
                        <IconButton className={classes.expand} onClick={handleDismiss} color="inherit">
                            <CloseIcon />
                        </IconButton>
                    </div>
                </CardActions>
            </Card>
        );
    })
);
